import {
  createSearchParams,
  Navigate,
  useSearchParams,
} from 'react-router-dom';

import { PATH } from '@constants';

export const ApplicationRedirectHandler: React.FC = () => {
  const [searchParams] = useSearchParams();

  const email = searchParams.get('login_hint');

  if (email) {
    const href = `${PATH.ORGANIZATIONS_INVITES}?${createSearchParams({
      login_hint: email,
    })}`;

    return <Navigate replace to={href} />;
  }

  return <Navigate replace to={PATH.HOME} />;
};
